class EventSlider {
    constructor() {
        this.cname = ".events-slider";
        this.components = document.querySelectorAll(this.cname);
        this.marginLeft = null;
        this.allData = null;

        if (this.components.length > 0) {
            this.init();
        }
    }

    init() {
        this.components.forEach((comp) => {
            const dropDownButton = comp.querySelector(".header__dropdown");
            let slider = comp.querySelector(".splide");

            if (dropDownButton) {
                this.handleDropDown(dropDownButton);
            }
            if (slider) {
                this.initializeSlider(slider);
            }
        });

        this.handleResize();
        window.addEventListener("resize", this.handleResize.bind(this), {
            passive: true,
        });
    }


    handleResize() {
        if (window.innerWidth >= 960) {
            this.components.forEach((comp) => this.applyMarginToLeftColumn(comp));
        }
    }

    applyMarginToLeftColumn(comp) {
        const fullWidth = window.innerWidth;
        const element = document.querySelector(".row.first");
        const maxWidth = parseFloat(window.getComputedStyle(element).getPropertyValue("max-width"));
        this.marginLeft = (fullWidth - maxWidth) / 2 - 8;

        const leftColumn = comp.querySelector(".row.second");
        if (leftColumn) leftColumn.style.marginLeft = `${this.marginLeft}px`;

        comp.classList.add("show");
    }

    handleDropDown(dropDown) {
        dropDown.addEventListener("click", (e) => {
            e.preventDefault();

            const { comp, value } = e.target.dataset;

            if (comp === "button-categories") {
                const parent = e.target.closest(".header__filters");
                parent?.classList.toggle("active");
            }

            if (value) {
                this.updateButtonText(dropDown, e.target);
                this.loadEvents(dropDown, value);
            }
        });
    }

    updateButtonText(dropDown, target) {
        const button = dropDown.querySelector("button");
        button.innerHTML = target.textContent + '<i class="icon-caret"></i>';
        const parent = dropDown.closest(".header__filters");
        parent?.classList.remove("active");
    }

    loadEvents(dropDown, category) {
        const component = dropDown.closest(".events-slider");
        const slider = component.querySelector(".splide");
        const wrapperSlides = component.querySelector(".splide__list");
        let URLCATEGORY = false;

        if(category == 'all'){
            URLCATEGORY = `${site_url}/events`;
        } else {
            URLCATEGORY = `${site_url}/event_property/${category}`;
        }

        if(this.allData == null){
            this.allData = wrapperSlides.innerHTML;
        }

        this.toggleLoader(component, true);

        if(category == 'all'){
            wrapperSlides.innerHTML = this.allData;
            this.initializeSlider(slider);
            this.toggleLoader(component, false);
        } else {

            fetch(URLCATEGORY)
                .then((response) => response.text())
                .then((html) => {
                    const eventsContent = this.parseEventsHTML(html);
                    wrapperSlides.innerHTML = eventsContent;
                    this.initializeSlider(slider);
                })
                .catch((error) => {
                    console.error("Error fetching events:", error);
                })
                .finally(() => this.toggleLoader(component, false));
        }

    }

    parseEventsHTML(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const events = doc.querySelectorAll(".events-slider .splide__slide");
        const eventsHTML = Array.from(events).map(event => event.outerHTML).join("");
        return eventsHTML;
    }

    initializeSlider(slider) {

        let slides = slider.querySelectorAll(".splide__slide");
        let sliderPagination = slider.querySelector(".splide__pagination");
        if (sliderPagination) sliderPagination.innerHTML = "";

        let splide = new Splide(slider, {
            type: slides.length > 4 ? "loop" : "slide",
            arrows: false,
            pagination: slides.length > 3 ? true : false,
            perMove: 1,
            gap: "3rem",
            autoWidth: true,
            mediaQuery: "max",
            breakpoints: {
                960: {
                    perPage: 1,
                    autoWidth: false,
                },
            },
        })

        splide.mount();
    }

    toggleLoader(component, show) {
        component.classList.toggle("show-loader", show);
    }
}

new EventSlider();
